import React, { useState } from "react";
import { Modal } from "./Modal";

export function WhatIsThisModal(props: {
  children?: React.ReactNode;
  modalTitle: React.ReactNode;
}) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  return (
    <>
      <Modal
        isModalVisible={isModalVisible}
        onSubmit={() => setIsModalVisible(false)}
        onClickOutside={() => setIsModalVisible(false)}
        {...props}
      />
      <button
        type="button"
        className="small-clickable"
        onClick={() => setIsModalVisible(true)}
      >
        <i className="fa fa-question-circle" />
      </button>
    </>
  );
}
